import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { BridgeElement } from "@hotwired/hotwire-native-bridge"

// Legacy bridge for older native app builds. Prefer bridge--action-button.
// Keep until store force-update; then remove with server emitters.
export default class extends BridgeComponent {
  static component = "navbar-action"

  connect() {
    super.connect()
    this.sendConnect()
  }

  disconnect() {
    this.send("disconnect", {})
    super.disconnect()
  }

  sendConnect() {
    const el = new BridgeElement(this.element)
    const iosImage = (el.bridgeAttribute("ios-image") || "").trim()
    const tintColor = el.bridgeAttribute("tint-color")
    const title = (el.bridgeAttribute("title") || "").trim()
    const payload = { iosImage }
    if (tintColor != null && String(tintColor).trim() !== "") {
      payload.tintColor = String(tintColor).trim()
    }
    if (title) payload.accessibilityLabel = title
    const callback = () => this.element.click()
    this.send("connect", payload, callback)
  }
}
